var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7526 1H4.93305C2.76087 1 1 2.76093 1 4.93311V21.7526C1 23.9248 2.76087 25.6857 4.93305 25.6857H21.7526C23.9247 25.6857 25.6857 23.9248 25.6857 21.7526V4.93311C25.6857 2.76093 23.9247 1 21.7526 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33984 24.7142L18.6654 7.46631",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6653 7.46631L25.6858 15.4265",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08778 10.9222C8.74149 10.9222 10.0821 9.58158 10.0821 7.92787C10.0821 6.27417 8.74149 4.93359 7.08778 4.93359C5.43408 4.93359 4.09351 6.27417 4.09351 7.92787C4.09351 9.58158 5.43408 10.9222 7.08778 10.9222Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6857,
    height: 26.6857,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeImage);
export default __webpack_public_path__ + "static/media/icon_type_image.4a7be14b4588ace1ded31c5fb7fe9a2e.svg";
export { ForwardRef as ReactComponent };